<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="params-line-wrapper">
    <SwitchSlide :is-active="!store.bypassQuery" @toggle="toggleUseRequest">
      Utiliser la requête
    </SwitchSlide>
    <CheckBox
      :checked="isAllSelected"
      @update:checked="
        () => (isAllSelected ? unselectAllFilters() : selectAllFilters())
      "
    >
      Toutes les activités
    </CheckBox>
  </div>
  <div class="params-line-wrapper space-between">
    <div class="filters-wrapper">
      <FilterCheckBox
        label="Dossiers Législatifs"
        color="var(--color-legidocs)"
        :is-checked="
          store.activitiesFilters.indexes.includes(ACTIVITIES_FILTERS.LEGIDOCS)
        "
        @check="addFilter(ACTIVITIES_FILTERS.LEGIDOCS)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.LEGIDOCS)"
      />
      <FilterCheckBox
        label="Amendements"
        color="var(--color-amendments)"
        :is-checked="
          store.activitiesFilters.indexes.includes(
            ACTIVITIES_FILTERS.AMENDMENTS
          )
        "
        @check="addFilter(ACTIVITIES_FILTERS.AMENDMENTS)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.AMENDMENTS)"
      />
      <FilterCheckBox
        label="Questions"
        color="var(--color-questions)"
        :is-checked="
          store.activitiesFilters.indexes.includes(ACTIVITIES_FILTERS.QUESTIONS)
        "
        @check="addFilter(ACTIVITIES_FILTERS.QUESTIONS)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.QUESTIONS)"
      />
    </div>

    <DropdownMenu
      v-model="selectedLimitOption"
      :options="limitOptions"
      label="Activités par page :"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import CheckBox from "@follaw-fr/components/reusable/atoms/CheckBox.vue";
import FilterCheckBox from "@follaw-fr/components/reusable/atoms/FilterCheckBox.vue";
import SwitchSlide from "@follaw-fr/components/reusable/atoms/SwitchSlide.vue";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";
import {
  useInstituGroupsStore,
  ACTIVITIES_FILTERS,
} from "@follaw-fr/stores/institutional-groups";

const route = useRoute();
const store = useInstituGroupsStore();

const { activitiesFilters } = storeToRefs(store);

const fetchActivities = () => {
  activitiesFilters.value.from = 0;
  store.fetchActivities(route.params._id);
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters: activitiesFilters,
    filterKey: "size",
    onChange: () => {
      fetchActivities();
    },
  });

const addFilter = (filter) => {
  activitiesFilters.value.indexes.push(filter);
  fetchActivities();
};

const showScrollTop = computed(() => activitiesFilters.value.size > 5);

const removeFilter = (filter) => {
  activitiesFilters.value.indexes = activitiesFilters.value.indexes.filter(
    (f) => f !== filter
  );
  fetchActivities();
};

const selectAllFilters = () => {
  activitiesFilters.value.indexes = Object.values(ACTIVITIES_FILTERS);
  fetchActivities();
};

const unselectAllFilters = () => {
  activitiesFilters.value.indexes = [];
  fetchActivities();
};

const isAllSelected = computed(
  () =>
    activitiesFilters.value.indexes.length ===
    Object.keys(ACTIVITIES_FILTERS)?.length
);

const toggleUseRequest = () => {
  store.bypassQuery = !store.bypassQuery;
  fetchActivities();
};
</script>

<style lang="scss" scoped>
.params-line-wrapper,
.filters-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &.params-line-wrapper {
    gap: 15px;
    &.space-between {
      justify-content: space-between;
    }
  }
  &.filters-wrapper {
    gap: 10px;
  }
}
</style>
